import AccountSettings from 'features/payOverTime/screens/AccountSettings/AccountSettings';
import React from 'react';

export default function Page() {
  return <AccountSettings />;
}
